import { useState } from 'react';
import { reportServer } from './session.js';

// Small "⋮" menu on a server card for reporting a bad/dead link. Lives as a sibling
// of the card's <a> (not inside it) so its clicks don't trigger the invite link or
// the course toggle.

const REASONS = [
  { value: 'broken', label: 'Invite is broken / expired' },
  { value: 'inactive', label: 'Server is inactive' },
  { value: 'wrong_course', label: 'Wrong course' },
  { value: 'spam', label: 'Spam / not a class server' },
];

export default function ReportMenu({ serverId }) {
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);

  // Stop clicks anywhere in the menu from bubbling to the card link / course toggle.
  const swallow = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const choose = (reason) => {
    setOpen(false);
    setDone(true);
    reportServer(serverId, reason);
  };

  if (done) {
    return <span className="report-done" onClick={swallow}>Reported ✓</span>;
  }

  return (
    <div className="report-menu" onClick={swallow}>
      <button
        type="button"
        className="report-toggle"
        aria-label="Report this server"
        onClick={(e) => {
          swallow(e);
          setOpen((o) => !o);
        }}
      >
        ⋮
      </button>
      {open && (
        <div className="report-dropdown">
          {REASONS.map((r) => (
            <button
              key={r.value}
              type="button"
              className="report-option"
              onClick={(e) => {
                swallow(e);
                choose(r.value);
              }}
            >
              {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
